import type { AxiosResponse } from 'axios';
import { accessTokenManager } from 'core/accessTokenManager';
import { jwtDecode } from 'jwt-decode';

/**
 * Picks up a transparently refreshed JWT from the response header.
 * Only stores it if the new token's exp is valid and >= the current token's exp,
 * preventing stale tokens from concurrent responses overwriting fresher ones.
 */
export const handleRefreshedToken = (response: AxiosResponse): void => {
  const refreshedToken = response.headers?.['x-refreshed-access-token'];
  if (!refreshedToken || typeof refreshedToken !== 'string') return;

  try {
    const { exp: newExp = 0 } = jwtDecode<{ exp?: number }>(refreshedToken);
    const now = Math.floor(Date.now() / 1000);
    if (newExp <= now) return;

    const currentToken = accessTokenManager.getAccessToken();
    const currentExp = currentToken ? (jwtDecode<{ exp?: number }>(currentToken).exp ?? 0) : 0;

    if (newExp >= currentExp) {
      accessTokenManager.setAccessToken(refreshedToken);
    }
  } catch {
    // Decoding failed — ignore to avoid overwriting with an invalid token
  }
};
